import React from 'react'
import UploadForm from './components/UploadForm'
import './App.scss'
import './styles/tailwind.css'

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <UploadForm />
            </header>
        </div>
    )
}

export default App
